<script setup>
import { onMounted, ref } from 'vue'
import Modal from '@/Components/New/Modal.vue'
import CircleCheckSvg from "@svg/new-circle-check.svg";

const emit = defineEmits()

defineProps({
    nextEpisode: Object
})

const autoplayFocus = ref(null)
let autoplayModalInterval
const autoplayCountdownFrom = 5
const autoplayModalCountdown = ref(autoplayCountdownFrom)

onMounted(() => {
    autoplayModalInterval = setInterval(() => {
        autoplayModalCountdown.value--

        if (autoplayModalCountdown.value > 0) {
            return
        }

        emit('ended')
    }, 1000)
})
</script>

<template>
    <Modal :initialFocus="autoplayFocus" :show="true" v-on:close="emit('cancel')" class="bg-[rgba(20,22,57,1)] max-w-md">
        <div class="p-12">
            <CircleCheckSvg class="size-20 mx-auto text-[rgba(25,140,255,1)] drop-shadow-[2px_2px_6px_rgba(25,140,255,0.5)]" />

            <div class="text-3xl font-semibold text-[rgba(233,232,255,1)] text-center leading-none mt-4">Episode complete</div>
            <div class="mt-4 text-[rgba(169,198,249,1)] text-center">Next up: <span class="text-[rgba(233,232,255,1)] text-center">{{ nextEpisode.title }}</span></div>

            <div class="relative mx-auto flex items-center justify-center mt-6">
                <div class="text-center text-4xl font-semibold mono bg-gradient-to-r to-[rgba(229,228,252,1)] from-[rgba(31,73,174,1)] text-transparent bg-clip-text">
                    0:0<span class="w-8 inline-block text-left">{{ autoplayModalCountdown }}</span>
                </div>
            </div>

            <div class="flex items-center space-x-3 mt-10">
                <button v-on:click="emit('cancel')" class="bg-[rgba(27,32,74,1)] rounded-full font-medium text-[rgba(148,162,209,1)] w-full h-12 leading-none text-sm">
                    Cancel
                </button>
                <button ref="autoplayFocus" v-on:click="emit('ended')" class="bg-[rgba(25,140,255,1)] rounded-full font-medium text-[rgba(235,248,255,1)] w-full h-12 leading-none drop-shadow-[2px_3px_5px_rgba(25,140,255,0.5)] text-sm">
                    Play next
                </button>
            </div>
        </div>
    </Modal>
</template>
